import { isEmpty } from "lodash";
import {
  RESET_SUMMARY,
  SET_BOOKING_PERIOD,
  SET_DATE,
  SET_EXPERIENCE_ID,
  SET_START_TIME,
  SUMMARY_ADD_ITEM,
  SUMMARY_ADD_TICKET,
  SUMMARY_SUBTRACT_ITEM,
  SUMMARY_SUBTRACT_TICKET,
  SUMMARY_REMOVE_TICKET_RATE,
  RESET_SUMMARY_PRODUCTS,
  SET_PICK_UP_AND_DROP_OFF_BRANCH,
  SET_SELECTED_PRODUCTS,
  REMOVE_SELECTED_PRODUCT,
  RESET_SELECTED_PRODUCTS,
} from "../actions/shopActions";

const INITIAL_STATE = {
  products: {},
  experienceId: null,
  dates: {
    daysQuantity: 1,
    from: new Date(),
    to: new Date(),
  },
  period: null,
  startTimeId: null,
  tickets: {},
  pickUpBranch: {},
  dropOffBranch: {},
  selectedProducts: [],
};

const setItemQuantity = (products, productId, quantity) => {
  const productsCopy = { ...products };
  if (isEmpty(productId)) {
    return { ...productsCopy };
  }
  if (quantity > 0) {
    return {
      ...productsCopy,
      [productId]: quantity,
    };
  }
  delete productsCopy[productId];
  return productsCopy;
};

const removeSelectedProduct = (products, fieldKey) => {
  return products.filter((product) => product.fieldKey !== fieldKey);
};

const summaryShopReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SUMMARY_ADD_ITEM:
      return {
        ...state,
        products: setItemQuantity(
          state.products,
          payload.productId,
          state.products[payload.productId]
            ? state.products[payload.productId] + 1
            : 1
        ),
      };
    case SUMMARY_SUBTRACT_ITEM:
      return {
        ...state,
        products: setItemQuantity(
          state.products,
          payload.productId,
          state.products[payload.productId]
            ? state.products[payload.productId] - 1
            : 0
        ),
      };
    case SET_EXPERIENCE_ID:
      return {
        ...state,
        experienceId: payload.experienceId,
      };
    case SUMMARY_ADD_TICKET:
      return {
        ...state,
        tickets: setItemQuantity(
          state.tickets,
          payload.ticketRate,
          state.tickets[payload.ticketRate]
            ? state.tickets[payload.ticketRate] + 1
            : 1
        ),
      };
    case SUMMARY_SUBTRACT_TICKET:
      return {
        ...state,
        tickets: setItemQuantity(
          state.tickets,
          payload.ticketRate,
          state.tickets[payload.ticketRate]
            ? state.tickets[payload.ticketRate] - 1
            : 0
        ),
      };
    case SUMMARY_REMOVE_TICKET_RATE: {
      const { [payload.ticketRate]: removedRate, ...tickets } = state.tickets;
      return {
        ...state,
        tickets,
      };
    }
    case SET_DATE:
      return {
        ...state,
        dates: {
          ...payload.dates,
        },
      };
    case SET_BOOKING_PERIOD:
      return {
        ...state,
        period: payload.period,
      };
    case SET_START_TIME:
      return {
        ...state,
        startTimeId: payload.id,
      };
    case RESET_SUMMARY:
      return {
        INITIAL_STATE,
      };
    case RESET_SUMMARY_PRODUCTS:
      return {
        ...state,
        products: {},
      };
    case SET_PICK_UP_AND_DROP_OFF_BRANCH:
      return {
        ...state,
        [payload.key]: {
          _id: payload.branch,
          name: payload.branchName,
        },
      };
    case SET_SELECTED_PRODUCTS:
      return {
        ...state,
        selectedProducts: payload.selectedProducts,
      };
    case REMOVE_SELECTED_PRODUCT:
      return {
        ...state,
        selectedProducts: removeSelectedProduct(
          state.selectedProducts,
          payload.fieldKey
        ),
      };
    case RESET_SELECTED_PRODUCTS:
      return {
        ...state,
        selectedProducts: [],
      };
    default:
      return state;
  }
};

export default summaryShopReducer;
